import { Children, useState, useEffect } from "react";
function SummaryText({ title, children }) {
  // handle small screens with react inline styles
  const mediaMatch = window.matchMedia("(max-width: 500px");
  const [matches, setMatches] = useState(mediaMatch.matches);
  let childArray = Children.toArray(children);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [matches]); // eslint-disable-line react-hooks/exhaustive-deps

  const Styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: matches ? "left" : "center",
      justifyContent: "center",
      width: matches ? "90vw" : "28rem",
    },
    title: {
      fontSize: "0.9rem",
      fontWeight: "bold",
      paddingBottom: "0.6rem",
    },
    center: {
      display: "flex",
      alignItems: matches ? "left" : "center",
      flexDirection: "column",
    },
  };

  return (
    <div style={Styles.container}>
      <p style={Styles.title}>{title}</p>
      <div style={Styles.center}>{childArray}</div>
    </div>
  );
}

export default SummaryText;
